export default "__VITE_ASSET__CZuMSouF__"